export default __webpack_public_path__ + "static/media/jsrbrtable_Lnds.182e1b38.webp";